export class CampaignAttributionMetricsBuilder {
  constructor() {
    this.metrics = {};
  }

  setOrderedWithin5DaysRatio(orderedWithin5DaysRatio) {
    this.metrics.orderedWithin5DaysRatio = orderedWithin5DaysRatio;
    return this;
  }

  setOrderedRecommendedCategoryRatio(orderedRecommendedCategoryRatio) {
    this.metrics.orderedRecommendedCategoryRatio =
      orderedRecommendedCategoryRatio;
    return this;
  }

  setLastTouchRatio(lastTouchRatio) {
    this.metrics.lastTouchRatio = lastTouchRatio;
    return this;
  }

  setUsedExactDiscountCodeRatio(usedExactDiscountCodeRatio) {
    this.metrics.usedExactDiscountCodeRatio = usedExactDiscountCodeRatio;
    return this;
  }

  setUsesAnyDiscountCodeRatio(usesAnyDiscountCodeRatio) {
    this.metrics.usesAnyDiscountCodeRatio = usesAnyDiscountCodeRatio;
    return this;
  }

  setOrderedRecommendedProductRatio(orderedRecommendedProductRatio) {
    this.metrics.orderedRecommendedProductRatio =
      orderedRecommendedProductRatio;
    return this;
  }

  build() {
    return this.metrics;
  }
}
